export default __webpack_public_path__ + "static/plug_b.1dcd426558c3c0d16ab4d671bef7e9a4.svg";